import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeMyTrainingsIndexPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CoursesDatatable } from './CoursesDatatable'
import { NextSessionRow } from './NextSessionRow'

export const Overview = () => {
  const { access } = useCurrentSession()
  const { data } = useQuery(EmployeeMyTrainingsIndexPageDocument, {
    variables: { accessId: access.id, next: true },
  })

  const sessions = data?.trainings.trainingsConnection.nodes.flatMap(
    (training) => training.sessions
  )

  const session = sessions ? sessions[0] : undefined
  return (
    <Box gap="s40">
      {session && <NextSessionRow session={session} />}
      <CoursesDatatable />
      <Outlet />
    </Box>
  )
}
